import { render, staticRenderFns } from "./InviteFriend.vue?vue&type=template&id=50e0684e&scoped=true&"
import script from "./InviteFriend.vue?vue&type=script&lang=js&"
export * from "./InviteFriend.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriend.vue?vue&type=style&index=0&id=50e0684e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0684e",
  null
  
)

component.options.__file = "InviteFriend.vue"
export default component.exports